import { IDBPDatabase, openDB } from 'idb';

const metaTables = ['meta'];
const mainTables = [
	'User',
	'Branch:ownerId',
	'Supplier:ownerId',
	'Template:branchId:supplierId',
	'Order:templateId',
	'Advertisement',
	'SpecialOffer:supplierId',
	'Message:parameter',
	'Reminder:templateId',
	'AccessTemplate:templateId',
	'PublicSupplier',
	'MasterSupplier',
	'Brand',
	'AdCountdown',
	'Category:categoryId',
	'Harmonizer',
	'AdminSupplier',
	'AdmUserPage',
	'UserStat',
	'DbStat',
	'Coupon',
  'SupplierItemExt',
	'ItemCustomization',
	'Harmonization',
];
const itemTables = [
	'SupplierItem:supplierId',
	'SpecialOffer:supplierId',
	'TemplateItem:templateId',
	'OrderItem:orderId',
	'AdvertiserOfferInCatalogs:supplierId',
	'SupplierItemExt:supplierId',
];

function upgrade(upgradeDb) {
	for (const t of metaTables) {
		if (upgradeDb.objectStoreNames.contains(t)) continue;
		upgradeDb.createObjectStore(t, {keyPath: 'id'});
	}
	for (const t of [...mainTables, ...itemTables]) {
		const name = t.replace(/:.*/, '');
		if (upgradeDb.objectStoreNames.contains(name)) continue;
		const store = upgradeDb.createObjectStore(name, {keyPath: 'id'});
		if (t === name) continue;
		for (const i of t.substring(name.length+1).split(':')) store.createIndex(i, i);
	}
}

// const dbNameFn = () => authStore.email + '-' + authStore.roleAsString + '-' + authStore.server

const dbNameFn = () => 'xxx'; // TODO

const cache: {name: string, value: Promise<IDBPDatabase<unknown>> | undefined} = {name: '', value: undefined};

export const dbPromise = () => {
	if (!('indexedDB' in window)) throw new Error('This browser doesn\'t support IndexedDB');

	const name = dbNameFn();
	if (name !== cache.name) {
		cache.name = name;
		cache.value = openDB(name, 1, {upgrade});
	}
	if (!cache.value) throw new Error('impossible: no dbPromise');
	return cache.value;
};
